/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1MotiActions = {
    Workout: 'workout',
    Emoti: 'emoti',
    EmotiMessage: 'emotiMessage'
} as const
export type V1MotiActions = (typeof V1MotiActions)[keyof typeof V1MotiActions]

export function instanceOfV1MotiActions(value: any): boolean {
    for (const key in V1MotiActions) {
        if (Object.prototype.hasOwnProperty.call(V1MotiActions, key)) {
            if (V1MotiActions[key as keyof typeof V1MotiActions] === value) {
                return true
            }
        }
    }
    return false
}

export function V1MotiActionsFromJSON(json: any): V1MotiActions {
    return V1MotiActionsFromJSONTyped(json, false)
}

export function V1MotiActionsFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1MotiActions {
    return json as V1MotiActions
}

export function V1MotiActionsToJSON(value?: V1MotiActions | null): any {
    return value as any
}

export function V1MotiActionsToJSONTyped(
    value: any,
    ignoreDiscriminator: boolean
): V1MotiActions {
    return value as V1MotiActions
}
